import { useSelector } from "react-redux";

export const useCurrentDate = () =>
  useSelector(state => state.currentDate.currentDate);
